import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  getPermissions,
  getGroups,
  createGroup,
  updateGroup,
  deleteGroup,
} from "../../../../../store/roleManagement/roleManagementSlice";
import ResourcePage from "./shared/ResourcePage";
import TagList from "./shared/TagList";

const thunks = { fetch: getGroups, create: createGroup, update: updateGroup, remove: deleteGroup };

const GroupsPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const permissions = useSelector((s) => s.roleManagement.permissions.data);

  useEffect(() => {
    dispatch(getPermissions());
  }, [dispatch]);

  const labelOf = useMemo(
    () => Object.fromEntries(permissions.map((p) => [p.key, p.name])),
    [permissions]
  );
  const options = useMemo(
    () => permissions.map((p) => ({ value: p.key, label: p.name })),
    [permissions]
  );
  const names = (keys = []) => keys.map((k) => labelOf[k] || k);

  const columns = [
    { key: "name", label: t("pages.role_management.name") },
    {
      key: "permissions",
      label: t("pages.role_management.permissions"),
      render: (value, row) => <TagList items={names(row.permissions)} max={4} />,
    },
  ];

  const viewFields = [
    { key: "name", label: t("pages.role_management.name") },
    {
      key: "permissions",
      label: t("pages.role_management.permissions"),
      fullWidth: true,
      render: (row) => <TagList items={names(row.permissions)} />,
    },
  ];

  const formFields = [
    { key: "name", label: t("pages.role_management.name"), type: "text", required: true },
    {
      key: "permissions",
      label: t("pages.role_management.permissions"),
      type: "checkboxes",
      options,
      required: true,
    },
  ];

  return (
    <ResourcePage
      resource="groups"
      singular="group"
      columns={columns}
      viewFields={viewFields}
      formFields={formFields}
      thunks={thunks}
      getInitialValues={(row) => ({ name: row.name ?? "", permissions: row.permissions ?? [] })}
      toPayload={(v) => ({ name: v.name, permissions: v.permissions })}
    />
  );
};

export default GroupsPage;